export function transformValue(firebase, value) {
	// Convert references to Firestore References
	if (value?._path?.segments) {
		return firebase.firestore().doc(value._path.segments.join("/"));
	}

	// Convert timestamps to Firestore Timestamps
	if (value?._seconds) {
		return new firebase.firestore.Timestamp(value._seconds, value._nanoseconds);
	}

	// Recursively transform nested objects
	if (value instanceof Object && !Array.isArray(value)) {
		return transformObject(firebase, value);
	}

	return value;
}

export function transformObject(firebase, object) {
	return Object.entries(object).reduce(
		(acc, [key, value]) => {
			acc[key] = transformValue(firebase, value);

			return acc;
		},
		{
			id: object.objectID || object.id,
			exists: true,
		},
	);
}

export default function algoliaToFirestoreDocument(firebase) {
	return (objects) => objects.map((object) => transformObject(firebase, object));
}
